/* eslint-disable lingui/no-unlocalized-strings */
import { ErrorMessage } from "@reactive-resume/utils";

export const translateError = (error: ErrorMessage) => {
  switch (error) {
    case ErrorMessage.InvalidCredentials: {
      return `用户名或密码错误，请重新输入`;
    }
    case ErrorMessage.UserAlreadyExists: {
      return `该邮箱或用户名已被注册`;
    }
    case ErrorMessage.SecretsNotFound: {
      return `用户密钥记录丢失，请联系开发者`;
    }
    case ErrorMessage.OAuthUser: {
      return `此邮箱已关联其他账号，请使用相应的登录方式`;
    }
    case ErrorMessage.InvalidResetToken: {
      return `重置密码链接已失效，请重新发起密码重置`;
    }
    case ErrorMessage.InvalidVerificationToken: {
      return `验证链接已失效，请重新发起验证`;
    }
    case ErrorMessage.EmailAlreadyVerified: {
      return `该邮箱已完成验证`;
    }
    case ErrorMessage.TwoFactorNotEnabled: {
      return `该账号未开启双重认证`;
    }
    case ErrorMessage.TwoFactorAlreadyEnabled: {
      return `该账号已开启双重认证`;
    }
    case ErrorMessage.InvalidTwoFactorCode: {
      return `双重认证验证码无效，请重新输入`;
    }
    case ErrorMessage.InvalidTwoFactorBackupCode: {
      return `备用验证码无效或已使用，请重试`;
    }
    case ErrorMessage.InvalidBrowserConnection: {
      return `连接浏览器失败，请确保 Chrome 浏览器正在运行且可访问`;
    }
    case ErrorMessage.ResumeSlugAlreadyExists: {
      return `该简历标识已存在，请使用其他唯一标识符`;
    }
    case ErrorMessage.ResumeNotFound: {
      return `未找到该简历`;
    }
    case ErrorMessage.ResumeLocked: {
      return `简历已锁定，如需修改请先解锁`;
    }
    case ErrorMessage.ResumePrinterError: {
      return `简历打印失败，请稍后重试`;
    }
    case ErrorMessage.ResumePreviewError: {
      return `简历预览生成失败，请稍后重试`;
    }
    case ErrorMessage.SomethingWentWrong: {
      return `处理请求时出错，请稍后重试`;
    }

    default: {
      return null;
    }
  }
};
